module.exports = __webpack_public_path__ + "static/media/Lumen.ef3f185a.png";